import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const CertificationPageCover = ({ cover, icon, name, title, seo_wording }) => (
  <StaticQuery
    query={graphql`
      query {
        eruboshiCover: file(
          relativePath: {
            eq: "covers/certification-cover/certification_cover_01@2x.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        kuruminCover: file(
          relativePath: {
            eq: "covers/certification-cover/certification_cover_02@2x.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        nadeshikoCover: file(
          relativePath: {
            eq: "covers/certification-cover/certification_cover_03@2x.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        diversity100Cover: file(
          relativePath: {
            eq: "covers/certification-cover/certification_cover_04@2x.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        eruboshiIcon: file(
          relativePath: { eq: "certifications/eruboshi-3.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        kuruminIcon: file(
          relativePath: { eq: "certifications/kurumin-5.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        nadeshikoIcon: file(
          relativePath: { eq: "certifications/nadeshiko-6.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        diversity100Icon: file(
          relativePath: { eq: "certifications/diversity_100-6.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => {
      return (
        <div className="w-100 certification-wrapper">
          <Img
            className="certification-cover"
            fluid={data[cover].childImageSharp.fluid}
          />
          <div className="certification-info max-1100">
            <div className="certification-icon">
              <Img
                className="certification-cover"
                fluid={data[icon].childImageSharp.fluid}
              />
            </div>
            <h1>
              <span className="text-green">{name}</span>
              {title.replace(name, '')}
            </h1>
            <p
              dangerouslySetInnerHTML={{
                __html: seo_wording.replace('。', '。<br />'),
              }}
            />
          </div>
        </div>
      );
    }}
  />
);

export default CertificationPageCover;
